import FeatureGates from "@atlaskit/feature-gate-js-client";
import { ProductKeys } from "@atlassiansox/asc-stargate";

import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint";
import { LicenseContextProvider } from "@/components/license-provider/src";
import { SiteSelectorContextProvider } from "@/components/site-selector-modal";
import { IntercomProvider } from "@/libraries/intercom/src";
import { JiraServiceManagementSoftwarePageTemplate } from "@/templates/software/jira/service-management/jira-service-management-software-page/src";

export const JiraServiceManagementSoftwarePage = () => {
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = FeatureGates.checkGate(
        "gwp-737-enable-intercom-chat-jsm"
    );

    return (
        <LicenseContextProvider>
            <SiteSelectorContextProvider
                analyticsPrefix="jsm.show"
                productKey={ProductKeys.JIRA_SERVICE_DESK}
            >
                <IntercomProvider
                    appId={"p0ww63i2"}
                    triggerBoot={isBootIntercom}
                >
                    <CrossFlowTouchpointProvider
                        productKeys={[ProductKeys.JIRA_SERVICE_DESK]}
                        screenName="wacJsmProductTourPage"
                    >
                        <JiraServiceManagementSoftwarePageTemplate />
                    </CrossFlowTouchpointProvider>
                </IntercomProvider>
            </SiteSelectorContextProvider>
        </LicenseContextProvider>
    );
};
